import { useAppStore } from '@/stores/app/app'
import { computed, watch } from 'vue'

export function useMaintenance() {
   const storeApp = useAppStore()
   const maintenance = computed(() => storeApp.maintenance)

   return maintenance
}

export function useEnvironment() {
    const storeApp = useAppStore()
    const environment = computed(() => storeApp.environment)

   return environment
}

const config = {
   localMedia: '/images',

   files: {
      defaultView: 'grid'
   }
}

export default config